// ONE-CLICK [temporary — see docs/refactoring/ONE-CLICK-UPGRADE-FEATURE.md]
//
// Default (English) labels for the one-click panel, merged into the block's
// getLabels(). Customer-portal overrides them via [labels] i18n keys; operators
// keeps the English defaults (it does not pass [labels]).

export const ONE_CLICK_LABELS = {
  oneClickTitle: 'One Click update',
  oneClickDescription:
    'This inverter supports full-package updates: ARM, DSPM, DSPS and Safety are always updated together.',
  oneClickArmFirstExplain:
    'To enable the One Click update, the ARM module must be updated first. When the ARM update completes, the full update becomes available.',
  oneClickArmFirstCta: 'Update ARM',
  oneClickArmUpdating: 'ARM update in progress. The device may go offline temporarily…',
  oneClickCta: 'Update all modules',
  oneClickConfirmMessage:
    'All modules will be updated together:\n\n{moduleList}\n\nThe inverter will restart several times. Continue?',
  oneClickUpdating: 'Full update in progress… The logger may disconnect temporarily.',
  oneClickSuccess: 'All modules updated successfully.',
  oneClickFailed: 'Update failed. You can retry.',
  oneClickRetry: 'Retry',
  oneClickBlocked: 'This device cannot be updated remotely. Please contact support.',
  oneClickUnknown: 'Could not verify update availability. Please retry.',
} as const;

export type OneClickLabels = typeof ONE_CLICK_LABELS;
